
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/preparing-for-law-seminars",
      function () {
        return require("private-next-pages/resources/preparing-for-law-seminars.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/preparing-for-law-seminars"])
      });
    }
  